import { Box, Image } from '@chakra-ui/react';
import { ResellerBannerDTO } from 'core/api';
import { Electron } from 'pos/common';
import { ThemeManager } from 'pos/ui';
import * as React from 'react';

export function ResellerBanner({ Base64Image, Action }: ResellerBannerDTO): React.ReactNode {

	const showBanner = ThemeManager.isWebPos() && Base64Image;

	const handleClick = () => {
		if (Action.startsWith('http'))
			window.open(Action);
		else if (Action !== '' && Electron.isEnabled())
			void Electron.ProcessManager.start(Action);
	};

	return showBanner
		? <Box width={'68'} h={'18'} cursor={'pointer'}>
			<Image
				src={`data:image/png;base64,${Base64Image}`}
				onClick={handleClick}
				width={'full'}
				height={'full'}
				borderRadius={'md'}
				fit={'contain'}
				alt={''}
			/>
		</Box>
		: null;
}